var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.205 23.55C52.725 34.78 38.492 36.87 31.06 36.51c-6.503.822-21.083 1.018-27.384-4.782-7.876-7.251-.243-23.14 13.45-28.077 13.692-4.936 29.928 5.862 33.079 19.9Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 51,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.205 23.55C52.725 34.78 38.492 36.87 31.06 36.51c-6.503.822-21.083 1.018-27.384-4.782-7.876-7.251-.243-23.14 13.45-28.077 13.692-4.936 29.928 5.862 33.079 19.9Z",
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.298 32.877c7.683 0 13.911-5.543 13.911-12.38 0-6.837-6.228-12.38-13.911-12.38s-13.911 5.543-13.911 12.38c0 2.993 1.194 5.738 3.18 7.879a.99.99 0 0 0-.483.725l-.452 3.263a.998.998 0 0 0 1.366 1.062l3.033-1.237a.994.994 0 0 0 .618-.816 15.22 15.22 0 0 0 6.649 1.503Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.291,
    y: 13.8,
    width: 2.419,
    height: 9.335,
    rx: 1.21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.419,
    height: 2.841,
    rx: 1.21,
    transform: "matrix(1 0 0 -1 24.291 27.6)",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.387,
    y1: 9.81,
    x2: 36.481,
    y2: 39.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyPayIcon);
export default __webpack_public_path__ + "static/media/notify-pay-icon.2fa32e5aa85454a1f35af896e55ccbdf.svg";
export { ForwardRef as ReactComponent };